// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';
import FormData from 'form-data';
import { Moment } from 'moment';
import { Inject, Scoped } from 'vue-di';

/* tslint:disable:no-unused-locals */
import {
    Serializer,
    UNKNOWN_BASE_TYPE,
    GatewayError,
    PatientModelResponse,
    PatientResponseModel,
    PatientSaveModel,
    PatientSearchModel,
    PatientSearchModelResponse,
    PatientTCEntLib2SecuritySecureModelsSecureInt64Response,
    SecureUpsearchModelPatientPatientUpsearchModel,
} from '@trialcard/apigateway.models';
import { Authentication, ApiKeyAuth, OAuth, OAuthTokenProvider, NullAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import * as enums from '@trialcard/enums';
import {
    createAxiosHeaders,
    EntLibServiceClient,
    RequestFile,
    X_TC_USERID,
    ConfigureWith,
    SetPackageName,
} from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols.js';
import { configure } from './configure.js';

// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================

@Scoped
@ConfigureWith(configure)
@SetPackageName('@trialcard/apigateway.client')
export class PatientV3Api extends EntLibServiceClient {
    protected authentications: {
        'Token': Authentication;
        'UserId': ApiKeyAuth;
    }

    public constructor(
        @Inject(AXIOS) private readonly axios: AxiosInstance,
        @Inject(X_TC_USERID) xTcUserId: string,
        @Inject(AUDIENCE) audience: string,
        @Inject(BASE_PATH) url: string,
        @Inject(OAUTH_TOKEN_PROVIDER) tokenProvider: OAuthTokenProvider) {
        super();
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'UserId': new ApiKeyAuth('header', 'x-tc-userid'),
        };

        if ((this.authentications as any).UserId) {
            (this.authentications as any).UserId.apiKey = xTcUserId;
        }
    }

    /**
     * 
     * @summary Create a new Patient.
     * @param patientSaveModel Patient details
     */
    public async patientCreateByTenantId (patientSaveModel: PatientSaveModel): Promise<AxiosResponse<PatientTCEntLib2SecuritySecureModelsSecureInt64Response>> {
        const _url_ = '/patient/v3/Patient';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'patientSaveModel' is not null or undefined
        if (patientSaveModel === null || patientSaveModel === undefined) {
            throw new Error('Required parameter patientSaveModel was null or undefined when calling patientCreateByTenantId.');
        }


        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(patientSaveModel, "PatientSaveModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PatientTCEntLib2SecuritySecureModelsSecureInt64Response>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PatientTCEntLib2SecuritySecureModelsSecureInt64Response");
        }
        return response;
    }
    /**
     * 
     * @summary Get a Patient
     * @param patientId Patient ID
     */
    public async patientGetByTenantId (patientId: string): Promise<AxiosResponse<PatientModelResponse>> {
        const _url_ = '/patient/v3/Patient/{patientId}'
            .replace('{' + 'patientId' + '}', encodeURIComponent(String(patientId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'patientId' is not null or undefined
        if (patientId === null || patientId === undefined) {
            throw new Error('Required parameter patientId was null or undefined when calling patientGetByTenantId.');
        }


        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PatientModelResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PatientModelResponse");
        }
        return response;
    }
    /**
     * 
     * @summary Search for Patients.
     * @param patientSearchModel Search criteria
     */
    public async patientSearchByTenantId (patientSearchModel: PatientSearchModel): Promise<AxiosResponse<PatientSearchModelResponse>> {
        const _url_ = '/patient/v3/PatientSearch';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'patientSearchModel' is not null or undefined
        if (patientSearchModel === null || patientSearchModel === undefined) {
            throw new Error('Required parameter patientSearchModel was null or undefined when calling patientSearchByTenantId.');
        }


        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(patientSearchModel, "PatientSearchModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PatientSearchModelResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PatientSearchModelResponse");
        }
        return response;
    }
    /**
     * 
     * @summary Update a Patient.
     * @param patientId Patient ID
     * @param patientSaveModel Patient details
     */
    public async patientUpdateByTenantId (patientId: string, patientSaveModel: PatientSaveModel): Promise<AxiosResponse<PatientResponseModel>> {
        const _url_ = '/patient/v3/Patient/{patientId}'
            .replace('{' + 'patientId' + '}', encodeURIComponent(String(patientId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'patientId' is not null or undefined
        if (patientId === null || patientId === undefined) {
            throw new Error('Required parameter patientId was null or undefined when calling patientUpdateByTenantId.');
        }

        // verify required parameter 'patientSaveModel' is not null or undefined
        if (patientSaveModel === null || patientSaveModel === undefined) {
            throw new Error('Required parameter patientSaveModel was null or undefined when calling patientUpdateByTenantId.');
        }


        const requestConfig: AxiosRequestConfig = {
            method: 'PUT',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(patientSaveModel, "PatientSaveModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PatientResponseModel>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PatientResponseModel");
        }
        return response;
    }
    /**
     * 
     * @summary Create a new Patient.
     * @param secureUpsearchModelPatientPatientUpsearchModel Patient details
     */
    public async patientUpsearchByTenantId (secureUpsearchModelPatientPatientUpsearchModel: SecureUpsearchModelPatientPatientUpsearchModel): Promise<AxiosResponse<PatientTCEntLib2SecuritySecureModelsSecureInt64Response>> {
        const _url_ = '/patient/v3/PatientUpsearch';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'secureUpsearchModelPatientPatientUpsearchModel' is not null or undefined
        if (secureUpsearchModelPatientPatientUpsearchModel === null || secureUpsearchModelPatientPatientUpsearchModel === undefined) {
            throw new Error('Required parameter secureUpsearchModelPatientPatientUpsearchModel was null or undefined when calling patientUpsearchByTenantId.');
        }


        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(secureUpsearchModelPatientPatientUpsearchModel, "SecureUpsearchModelPatientPatientUpsearchModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PatientTCEntLib2SecuritySecureModelsSecureInt64Response>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PatientTCEntLib2SecuritySecureModelsSecureInt64Response");
        }
        return response;
    }
}
